'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _DatePicker = require('material-ui/DatePicker');

var _DatePicker2 = _interopRequireDefault(_DatePicker);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var NitroFormDatePicker = function NitroFormDatePicker() {
  return _react2.default.createElement(_DatePicker2.default, {
    hintText: 'Choose date',
    mode: 'landscape'
  });
};

NitroFormDatePicker.propTypes = {};

exports.default = NitroFormDatePicker;


//////////////////
// WEBPACK FOOTER
// ./~/nitro-components/build/nitro/nitro-form-date-picker/NitroFormDatePicker.js
// module id = 2907
// module chunks = 4